import CardSection from "../CardSection/cardSection";
import { useTranslation } from "react-i18next";
import { getGlobalSearchQueryURL } from '../../constants'

export default function PressReleaseSection({ page = 1, rows = 12, onTotal }) {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language || "en-us").toLowerCase();
  return (
    <CardSection
      tabLabel="Press Releases"
      apiUrl={`${getGlobalSearchQueryURL}?q=*&locale=${locale}&fl=title,description,primaryImage,documentType,documentTypeDate,url,cqTagsIdName_s&fq=documentType:Press%20Release&groupBy=documentType,yearMonth,cqTagsName_s,brands&sort=documentTypeDate&startDate=2018-01-01T00:00:00Z&endDate=2030-12-31T23:59:59Z`}
      onTotal={onTotal}
      page={page}
      rows={rows}
    />
  );
}
